import React, { useEffect, useCallback, useState} from 'react';
import {setZObjectTooltip} from 'actions/index.js';
import {moveEdgeOutlet} from './moveEdge.js';
import {useContainerCoords} from "components/hooks/useContainerCoords.js"
import {connect} from 'react-redux';
import {
    setDrawingPadEdge} from 'actions/index.js';
import Colors from 'components/Colors.js';

import '../../Messaging.scss';
const colors = new Colors();

const MessageOutlets = ({
    subSequence,
    drawingEdge,
    setDrawingPadEdge,
    effect,
    containerRef,
    setZObjectTooltip,
    scale
}) => { 
    let [hover, setHover] = useState(undefined);

   const {getXY} = useContainerCoords({containerRef, scale});

    useEffect(() => {
        if (hover) {
            let id = effect.zObject ? effect.zObject.id : effect.id;
            let pos = effect.state.windows.windowPositions[id];
            let height = effect.zObject ? effect.zObject.height || 25 : effect.height || 25;
            if (!pos) {
                return;
            }
            setZObjectTooltip(
                effect.subSequence.id,
                {x: pos.x + hover.i * 20, y: pos.y + height + 10},
                hover.text
            );
        } else {
            setZObjectTooltip(undefined);
        }
    }, [hover, effect]);

    const onMouseUp = useCallback((inletType, effect) => {
        let movingEdge= subSequence.state.pads.movingEdge;
        if (movingEdge) {
            setHover(undefined);
            moveEdgeOutlet(effect, inletType, movingEdge);
        }
    }, []);

    const onMouseOver = useCallback((outlet, i) => {
        setHover({
            text: effect.name ? effect.name + ": " + outlet : outlet,
            i});
    }, [setHover]);

    const onMouseDown = useCallback((e, type, outletNumber, effect) => {
        e.stopPropagation();
        let fullType = effect.getFullType(type);
        let coords = {
            x: e.clientX,
            y: e.clientY
        };
        let sub = subSequence || effect.subSequence || (effect.track && effect.track.subSequence);
        let edgesPadding = sub.state.spatial.edgesPadding;
        setDrawingPadEdge(sub.id, {
            ... coords,
            effect: effect,
            type: type,
            outputNumber: outletNumber,
            node: effect,
            x1: coords.x * (window._scale || 1),
            y1: coords.y * (window._scale || 1),
            x2: coords.x * (window._scale || 1),
            y2: coords.y * (window._scale || 1),
        });
    }, [subSequence]);
    if (!effect.outlets) { return ''; }
    let outlets = Object.keys(effect.outlets);
    let moreOutlets = [];
    let outletDocs = [];
        if (effect.effect && effect.effect.inlets && (!effect.effect.hasInstances || effect.effect.showAllOutlets)) {
        let keys = Object.keys(effect.effect.outlets)
            .filter(k => !outlets.includes(k));
        moreOutlets = keys;
        let obj = effect.effect;
        for (let i=0; i < keys.length; i++) {
            if (obj.outletObjects && obj.outletObjects[i] && obj.outletObjects[i]._text !== '') {
                outletDocs[i] = obj.outletObjects[i]._text;
            } else {
                outletDocs[i] = keys[i];
            }
        }
    }

    let getStyle = (name) => drawingEdge && drawingEdge.type === name ?
        {
            backgroundColor: colors.getColorForHash(name)
        } : {};
 
    return (
        <div className="outlets">
          {/*hover && <div className="msg-tooltip"><div className="dot"/>{hover}</div>*/}
          {outlets.map(
              (outlet, i) => <div
                               key={outlet}
                               onMouseLeave={() => setHover(undefined)}
                               style={getStyle(outlet)}
                               onMouseOver={() => onMouseOver(outlet, i)}
                               onMouseDown={(e) => onMouseDown(e, outlet, i, effect)}
                               onMouseUp={() => onMouseUp(outlet, effect)}
                               id={effect.getFullType(outlet)}
                               className={effect.isOutletConnected(outlet) ? "outlet connected" :"outlet"}/>)}
          {moreOutlets.map(
              (outlet, i) => <div
                               key={outlet}
                               onMouseLeave={() => setHover(undefined)}
                               onMouseOver={() => onMouseOver(outletDocs[i], outlets.length + i)}
                               onMouseUp={() => onMouseUp(outlet, effect.effect)}
                               style={getStyle(outlet)}
                               onMouseDown={(e) => onMouseDown(e, outlet, i, effect.effect)}
                               id={effect.effect.getFullType(outlet)}
                               className={effect.effect.isOutletConnected(outlet) ? "outlet connected" :"outlet"}/>)}
        </div>);
};

const mapStateToProps = (state, props) => {
    let subSequence = props.effect.subSequence || (props.effect.track && props.effect.track.subSequence);
    if (props.effect.effect) {
        return {
            numOutlets: props.effect.numOutlets + props.effect.effect.numOutlets,
            drawingEdge: subSequence && state.pads.drawingEdges[subSequence.id],
        };
    }
    return {
        numOutlets: props.effect.numOutlets,
        movingEdge: state.pads.movingEdge,
        drawingEdge: subSequence && state.pads.drawingEdges[subSequence.id],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setDrawingPadEdge: (x,y) => dispatch(setDrawingPadEdge(x,y)),
      setZObjectTooltip: (id, pos, text) => dispatch(setZObjectTooltip(id, pos, text))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageOutlets);
